import BasicProfile from 'components/channel/BasicProfile';
import ContentsData from 'components/channel/ContentsData';
import {
	Background,
	BodyInnerWrapper,
	BodyWrapper,
} from 'styles/styled-components/section';

const Channel = () => {
	return (
		<Background>
			<BodyWrapper options={{ scrollbars: { autoHide: 'move', autoHideDelay: 250 } }}>
				<BodyInnerWrapper>
					<BasicProfile />
					<ContentsData />
				</BodyInnerWrapper>
			</BodyWrapper>
		</Background>
	);
};

export default Channel;
